import axios from 'axios';

export default {
  state: {
    isLoading: false,
    fonts: [],
  },
  actions: {
    getFontsMetadata(context, { customerId, documentId }) {
      return axios
        .get(`/api/v2/customers/${customerId}/documents/${documentId}/fonts/`)
        .then((response) => {
          context.commit('setFontsMetadata', response.data);
          return response;
        });
    },
  },
  mutations: {
    setFontsMetadataLoading(state, loading) {
      state.isLoading = loading;

      if (loading) {
        state.document_fonts = {};
      }
    },
    setFontsMetadata(state, data) {
      state.fonts = data;
    },
  },
};
